/* Dauber HQ device-screen content fit (Firefox fallback).
 *
 * The device mockups — the room views (.rv / .rv--compact) and the phone fit
 * layer (.idev__fit--phone) — are authored at a FIXED natural px size and uniformly
 * scaled to fill their screen (a container-query size container) via
 * `transform: scale(calc(100cqw / <natural>))` in CSS. That calc divides a length
 * by a length to produce a number; Chrome/Safari support typed calc division,
 * Firefox does NOT — it drops the declaration and falls back to a static scale that
 * only fits at the cluster's default sizes, leaving content under-scaled (empty
 * screen around it) and the scan video narrow.
 *
 * Where length/length division is unsupported, measure each element and publish the
 * ratio as --ff-scale. The CSS sets `scale(var(--ff-scale))` on the line right
 * before the cqw line, so Firefox uses the measured value while Chrome/Safari keep
 * the native cqw path untouched. ResizeObserver re-fits on resize and when a hidden
 * cluster (the showcase "players" panel) becomes visible.
 */

(function () {
  'use strict';

  // Browsers with typed calc division use the pure-CSS cqw path — nothing to do.
  if (window.CSS && CSS.supports('transform', 'scale(calc(1px / 1px))')) return;

  var SEL = '.rv, .rv--compact, .idev__fit--phone';

  function fit(el) {
    var host = el.parentElement; // the .idev__screen size container
    if (!host) return;
    var natural = el.offsetWidth; // authored px width (transform doesn't change it)
    var avail = host.clientWidth;
    if (!natural || !avail) return; // hidden / not yet laid out → keep CSS fallback
    el.style.setProperty('--ff-scale', avail / natural);
  }

  function fitAll() {
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) fit(els[i]);
  }

  fitAll();
  window.addEventListener('load', fitAll);
  window.addEventListener('resize', fitAll, { passive: true });

  // Re-fit when a screen container resizes — including the 0→visible change when the
  // showcase toggles from the caller view to the device cluster.
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(fitAll);
    var els = document.querySelectorAll(SEL);
    for (var i = 0; i < els.length; i++) {
      if (els[i].parentElement) ro.observe(els[i].parentElement);
    }
  }
})();
